import React, { Component } from "react";
import PropTypes from "prop-types";
import "./SquareCustomerSync.scss";
import OwStaticTypeahead from "../../../shared/OwStaticTypeahead/OwStaticTypeahead";
import OwButton from "../../../shared/OwButton/OwButton";
import ActivityIndicator from "../../../shared/ActivityIndicator/ActivityIndicator";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";

type Props = {
    supplierModel: any;
    userModel: any;
    socket: any;
    squareCustomerData: any[];
    vendorData: any[];
    closeModalFn: any;
};

type State = {
    isSaving: boolean;
    isLoading: boolean;
    tbodyRows: any;
    vendorData: any;
    customerList: any[];
    directoryCustomerList: any[];
    importCustomerList: any[];
    invoicesCustomerList: any[];
    mergeCustomerList: any[];
};

class SquareCustomerSync extends Component<Props, State> {
    static defaultProps = {
        supplierModel: {},
        squareCustomerData: [],
        vendorData: [],
    };

    readonly state: State = {
        isSaving: false,
        isLoading: true,
        tbodyRows: null,
        vendorData: this.props.vendorData,
        customerList: [],
        directoryCustomerList: [],
        importCustomerList: [],
        invoicesCustomerList: [],
        mergeCustomerList: [],
    };

    componentDidMount() {
        const tbodyRows = this.getTableBodyRows();

        this.props.socket.on("onSquareSaveVendorCustomerMap", this.onSquareSaveVendorCustomerMap);
        this.props.socket.on("notify", this.notify);
        this.props.socket.on("onSquareSearchCustomers", this.onSquareSearchCustomers);

        this.getCustomerList();

        this.setState({
            tbodyRows,
            isLoading: false,
        });
    }

    componentWillUnmount() {
        this.props.socket.removeListener("onSquareSaveVendorCustomerMap", this.onSquareSaveVendorCustomerMap);
        this.props.socket.removeListener("notify", this.notify);
        this.props.socket.removeListener("onSquareSearchCustomers", this.onSquareSearchCustomers);
    }

    notify = () => {
        this.setState({
            isSaving: false,
        });
    };

    getCustomerList = () => {
        const payload = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            query: {
                filter: {
                    creation_source: {
                        values: ["MERGE", "IMPORT", "INVOICES", "DIRECTORY"],
                    },
                },
            },
        };

        this.props.socket.emit("squareSearchCustomers", payload);
    };

    onSquareSearchCustomers = (data: any) => {
        this.setState({
            customerList: data.customers,
        });
    };

    onSquareSaveVendorCustomerMap = (data: any) => {
        this.setState(
            {
                isSaving: false,
            },
            () => {
                this.closeModal();
            }
        );
    };

    saveData = () => {
        const vendorSquareCustomerMap = _.map(this.state.vendorData, (vendorToken) => {
            const vendor_id = vendorToken.Vendor.id;
            const square_customer_id = _.get(vendorToken, "Vendor.Vendor_Integration.square_customer_id", null);

            return { vendor_id, square_customer_id };
        });

        const payload = {
            vendorSquareCustomerMap,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit("squareSaveVendorCustomerMap", payload);

        this.setState({
            isSaving: true,
        });
    };

    handleChange = (item: any, index: number) => {
        const vendorData = this.state.vendorData;

        const square_customer_id = item.id;

        if (_.isNil(vendorData[index].Vendor.Vendor_Integration)) {
            vendorData[index].Vendor.Vendor_Integration = {};
        }

        vendorData[index].Vendor.Vendor_Integration["square_customer_id"] = square_customer_id;

        this.setState({
            vendorData,
        });
    };

    getTableBodyRows = () => {
        const rows = _.map(this.state.vendorData, (vendorToken: any, index: number) => {
            const Vendor = vendorToken.Vendor;
            const Vendor_Integration = Vendor.Vendor_Integration;

            const selectedSquareCustomerId = _.get(Vendor_Integration, "square_customer_id", " ");

            // console.log('selectedSquareCustomerId: ', selectedSquareCustomerId);
            console.log("this.props.squareCustomerData", this.props.squareCustomerData);

            const processedCustomerData: any = [];
            /*
      0:
      company_name: "Vendor One Inc."
      created_at: "2019-05-22T01:46:42.555Z"
      creation_source: "DIRECTORY"
      family_name: "Doe"
      given_name: "Jane"
      id: "KEG146Z79X7YKFHVYR20NTJGEM"
      preferences: {email_unsubscribed: false}
      updated_at: "2019-05-22T01:46:43Z"
       */

            _.each(this.props.squareCustomerData, (customer) => {
                const id = _.get(customer, "id");
                const name = !_.isNil(customer.company_name) ? customer.company_name : `${customer.given_name} ${customer.family_name}`;
                const email_address = _.get(customer, "email_address");

                const customerSetup = {
                    name,
                    id,
                    email_address,
                };

                processedCustomerData.push(customerSetup);
            });

            // const optionSelect = (
            //     <OwSelectOption
            //         options={processedCustomerData}
            //         valueProp={'id'}
            //         titleProp={'name'}
            //         fn={(e) => { this.handleSupplierChange(e, index) }}
            //         selectedOption={Vendor_Integration}
            //         selectedOptionProp={'square_customer_id'}
            //         name={'square_customer_id'}/>
            // );
            console.log("processedCustomerData", processedCustomerData);

            // const typeahead = <Typeahead
            //                     isSelectableFn={() => {return true;}}
            //                     typeaheadApiFn={() => {return;}}
            //                     typeaheadItems={processedCustomerData}
            //                     titleProp={'name'}
            //                     selectedItem={Vendor_Integration.square_customer_id}
            //
            //                     />
            const square_customer_id = _.get(Vendor_Integration, "square_customer_id", null);

            const typeahead = (
                <OwStaticTypeahead
                    typeaheadItems={processedCustomerData}
                    selectedItem={square_customer_id}
                    titleProp={"name"}
                    subTitleProp={"email_address"}
                    valueProp={"id"}
                    isSelectableFn={() => {
                        return true;
                    }}
                    selectedItemFn={(item: any) => {
                        this.handleChange(item, index);
                    }}
                    selectedItemTitleProp={""}
                    selectedItemValueProp={""}
                />
            );

            const key = Vendor.guid + selectedSquareCustomerId;

            return (
                <tr key={key} className={index % 0 ? "bg-dark" : ""}>
                    <td className={"w-50"}>{Vendor.name}</td>
                    <td className={"w-50"}>{typeahead}</td>
                </tr>
            );
        });

        return rows;
    };

    closeModal = () => {
        this.props.closeModalFn(null);
    };

    render() {
        const tbodyRows = this.getTableBodyRows();

        return (
            <div className="SquareCustomerSync p-3" style={{ height: "100%" }}>
                <div className={"row"} style={{ height: "2rem" }}>
                    <div className={"col d-flex justify-content-end"}>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                    </div>
                </div>

                <div className={"row mt-3"} style={{ height: "7rem" }}>
                    <div className={"col-12"}>
                        <OwTitle title={"square_customer_sync"} tag={"h4"} className={"d-inline-flex"} />
                    </div>

                    <ActivityIndicator active={this.state.isLoading} />

                    <div className={"col-12"}>
                        <table className={"table table-dark w-100"}>
                            <thead>
                                <tr>
                                    <th className={"w-50"}>
                                        <OwTitle
                                            title={"vendor"}
                                            tag={"h5"}
                                            supplierModel={this.props.supplierModel}
                                            isSupplierVendorOverride={true}
                                        />
                                    </th>
                                    <th className={"w-50"}>
                                        <OwTitle title={"square_customer"} tag={"h5"} />
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>

                <div style={{ height: "33rem", overflow: "scroll" }} className={"row " + (this.state.isLoading ? "d-none" : "")}>
                    <div className={"col-12"}>
                        <table className={"table table-dark w-100"}>
                            <tbody>{tbodyRows}</tbody>
                        </table>
                    </div>
                </div>

                <div className={"row justify-content-end"} style={{ height: "2rem" }}>
                    <div className={"col-12"}>
                        <div className={"mt-2"}>
                            <OwButton title={"save"} fn={this.saveData} active={this.state.isSaving} disabled={this.state.isSaving} />

                            <OwButton title={"cancel"} className={"ms-2 btn-danger"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SquareCustomerSync;
